
<h2 class="f-w-500 m-b-24" mat-dialog-title><strong>Carga masiva de usuarios</strong></h2>
<mat-dialog-content style="max-width: 800px">
  <div class="col-xl-12">
    <mat-card class="cardWithShadow theme-card">
      <mat-card-content class="b-t-1">

        <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
            <div class="row">
                <div class="col-sm-12">
                    <button
                        mat-flat-button
                        color="primary"
                        class="m-l-8"
                        (click)="generarPLantilla()">
                        Generar plantilla
                        <mat-icon class="m-r-10 cursor-pointer">upload</mat-icon>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <button
                        mat-flat-button
                        color="accent"
                        class="m-l-8"
                        (click)="subirPlantilla()">
                        Subir plantilla
                        <mat-icon class="m-r-10 cursor-pointer">upload</mat-icon>
                    </button>
                </div>
            </div>
        </div>        
      </mat-card-content>
    </mat-card>
    <div class="row justify-content-end">
      <div class="col-sm-2" style="display: contents;">
        <button
          mat-flat-button
          style="background-color: #7f7f7f; color: white;"
          class="m-l-8"
          (click)="closeDialogCarga()">
          Cerrar
          <mat-icon class="m-r-10 cursor-pointer">cancel</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
